// src/ConsumerApp/Screens/ProductDetails/components/ProductOptionsModal.js

import React from 'react';
import X from '../../../../assets/icons/X.svg';
import ProductOptionCard from './ProductOptionCard';

export default function ProductOptionsModal({
  visible = false,
  onClose,
  cardTitle = 'Add To Buy',
  productData,
  onAddOption,
  bucketItemsMap,
  customerId,
  hubId,
  purchaseType = 'BUY_NOW',
}) {
  if (!visible) return null;

  const optionsList = Array.isArray(productData)
    ? productData
    : productData?.product_variants || [];
  const optionsCount = optionsList.length;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.card} onClick={(e) => e.stopPropagation()}>
        {/* Header matching ProductOptionsBottomSheet.js */}
        <div style={styles.header}>
          <div>
            <h4 style={styles.title}>{cardTitle}</h4>
            <span style={styles.subTitle}>{optionsCount} options available</span>
          </div>
          <button type="button" style={styles.closeBtn} onClick={onClose}>
            <img src={X} alt="close" style={{ width: 16, height: 16 }} />
          </button>
        </div>

        {/* List of Options */}
        <div style={styles.list}>
          {optionsList.map((variantItem, idx) => {
            const vId = String(variantItem.product_id || variantItem.id || variantItem._id || idx);
            const savedQty = bucketItemsMap?.get(vId)?.quantity;
            const bId = bucketItemsMap?.get(vId)?.bucketId;

            return (
              <ProductOptionCard
                key={vId}
                item={variantItem}
                customerId={customerId}
                hubId={hubId}
                purchaseType={purchaseType}
                bucketId={bId}
                savedBucketQuantity={savedQty}
                onAddSuccess={(addedItem) => {
                  if (onAddOption) onAddOption(addedItem);
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    zIndex: 99999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(2px)',
    padding: 20,
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: '20px 24px',
    width: '100%',
    maxWidth: 480,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    maxHeight: '80vh',
    boxShadow: '0 8px 30px rgba(0,0,0,0.18)',
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #F1F5F9',
    paddingBottom: 12,
  },
  title: {
    margin: 0,
    fontSize: 16,
    fontWeight: '800',
    color: '#2B2A29',
  },
  subTitle: {
    fontSize: 12,
    color: '#707B8C',
    marginTop: 2,
    display: 'block',
  },
  closeBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    overflowY: 'auto',
    paddingRight: 4,
  },
};